<!-- Contract Detail "Sneak Peek" Panel - Material Design 3 -->
<div class="contract-detail-container">

  <!-- Header Section -->
  <mat-card class="detail-header-card" appearance="outlined">
    <mat-card-content>
      <div class="header-layout">

        <!-- Contract Name -->
        <div class="contract-name">
          <h2>{{ selectedContract?.nameOfContract || 'Untitled Contract' }}</h2>
        </div>

        <!-- Actions -->
        <div class="header-actions">
          <!-- View Contract Button -->
          <button
            mat-raised-button
            color="primary"
            [disabled]="viewContractDisabled()"
            (click)="viewContractDialog()"
            matTooltip="Open contract document in new tab">
            <mat-icon>description</mat-icon>
            View Contract
          </button>

          <!-- Overall Status Chip -->
          <mat-chip
            [class.status-green]="overallStatus() === 'Green'"
            [class.status-yellow]="overallStatus() === 'Yellow'"
            [class.status-red]="overallStatus() === 'Red'"
            class="status-chip">
            <mat-icon [class.icon-green]="overallStatus() === 'Green'"
                      [class.icon-yellow]="overallStatus() === 'Yellow'"
                      [class.icon-red]="overallStatus() === 'Red'">
              @if (overallStatus() === 'Green') {
                check_circle
              } @else if (overallStatus() === 'Yellow') {
                warning
              } @else {
                error
              }
            </mat-icon>
            {{ overallStatus() }}
          </mat-chip>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <mat-divider></mat-divider>

  <!-- Tabbed Content -->
  <mat-tab-group
    animationDuration="300ms"
    class="detail-tabs">

    <!-- Critical Dates Tab -->
    <mat-tab label="Critical Dates">
      <ng-template matTabLabel>
        <mat-icon class="tab-icon">event</mat-icon>
        Key Dates/Renewal Information
      </ng-template>

      <div class="tab-content">

        <!-- Quick Reference Date Cards -->
        <div class="quick-dates-grid">

          <!-- Card 1: Key Dates -->
          <mat-card appearance="outlined">
            <mat-card-header>
              <mat-card-title>Key Dates</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <div class="date-info-table">
                <div class="date-row">
                  <span class="date-label">Effective Date:</span>
                  <span class="date-value">
                    {{ (selectedContract?.effectiveDate | date:'shortDate') || 'N/A' }}
                  </span>
                </div>
                <div class="date-row">
                  <span class="date-label">Commencement:</span>
                  <span class="date-value">
                    {{ (selectedContract?.executionDate | date:'shortDate') || 'N/A' }}
                  </span>
                </div>
                @if (selectedContract?.expirationDate && selectedContract.expirationDate !== ' ') {
                  <div class="date-row">
                    <span class="date-label">Expiration:</span>
                    <span class="date-value">
                      {{ (selectedContract.expirationDate | date:'shortDate') || 'N/A' }}
                    </span>
                  </div>
                }
                <div class="date-row">
                  <span class="date-label">Next Review:</span>
                  <span class="date-value">
                    {{ (selectedContract?.nextReviewDate | date:'shortDate') || 'N/A' }}
                  </span>
                </div>
                <div class="date-row">
                  <span class="date-label">Last Review:</span>
                  <span class="date-value">
                    {{ (selectedContract?.lastReviewDate | date:'shortDate') || 'N/A' }}
                  </span>
                </div>
                <div class="date-row">
                  <span class="date-label">Internal Exec:</span>
                  <span class="date-value">
                    {{ (selectedContract?.internalExecutionDate | date:'shortDate') || 'N/A' }}
                  </span>
                </div>
              </div>
            </mat-card-content>
          </mat-card>

          <!-- Card 2: Renewal Information -->
          <mat-card appearance="outlined">
            <mat-card-header>
              <mat-card-title>Renewal Information</mat-card-title>
            </mat-card-header>
            <mat-card-content>
              <div class="date-info-table">
                <div class="date-row">
                  <span class="date-label">Renewal Type:</span>
                  <span class="date-value">{{ selectedContract?.renewalType || 'N/A' }}</span>
                </div>
                <div class="date-row">
                  <span class="date-label">Renewal Term:</span>
                  <span class="date-value">
                    @if (selectedContract?.renewalTerm) {
                      {{ selectedContract.renewalTerm }} months
                    } @else {
                      N/A
                    }
                  </span>
                </div>
                <div class="date-row">
                  <span class="date-label">Review Period:</span>
                  <span class="date-value">
                    @if (selectedContract?.reviewPeriod) {
                      {{ selectedContract.reviewPeriod }} days
                    } @else {
                      N/A
                    }
                  </span>
                </div>
                <div class="date-row">
                  <span class="date-label">Notice Period:</span>
                  <span class="date-value">
                    @if (selectedContract?.noticePeriod) {
                      {{ selectedContract.noticePeriod }} days
                    } @else {
                      N/A
                    }
                  </span>
                </div>
              </div>
            </mat-card-content>
          </mat-card>
        </div>
      </div>
    </mat-tab>

    <!-- Other Dates Tab -->
    <mat-tab label="Other Dates">
      <ng-template matTabLabel>
        <mat-icon class="tab-icon">date_range</mat-icon>
        Taskings and Reminders
        @if (criticalDates().length > 0) {
          <mat-chip class="count-badge">{{ criticalDates().length }}</mat-chip>
        }
      </ng-template>

      <div class="tab-content">
        @if (criticalDates().length > 0) {
          <div class="simple-table-container">
            <table class="simple-dates-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Event Date</th>
                  <th>Reminder Date</th>
                  <th>Assigned To</th>
                  <th>Required Action/Comments</th>
                  <th>Action Completed</th>
                </tr>
              </thead>
              <tbody>
                @for (date of criticalDates(); track date.criticalDateNum) {
                  <tr>
                    <td>{{ date.criticalDateData?.name || date.name || 'N/A' }}</td>
                    <td>{{ (date.criticalDateData?.eventDate || date.eventDate) | date:'shortDate' }}</td>
                    <td>{{ (date.criticalDateData?.reminderDate || date.reminderDate) | date:'shortDate' }}</td>
                    <td>{{ date.criticalDateData?.assignedTo || date.assignedTo || 'N/A' }}</td>
                    <td>{{ date.criticalDateData?.description || date.description || date.criticalDateData?.requiredAction || date.requiredAction || 'N/A' }}</td>
                    <td>
                      @if (date.criticalDateData?.actionCompleted || date.actionCompleted) {
                        <mat-icon class="icon-green">check_circle</mat-icon>
                      } @else {
                        <mat-icon class="icon-muted">radio_button_unchecked</mat-icon>
                      }
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        } @else {
          <div class="empty-state">
            <mat-icon>event_busy</mat-icon>
            <p>No critical dates associated with this contract</p>
          </div>
        }
      </div>
    </mat-tab>

    <!-- Alerts & Warnings Tab -->
    <mat-tab label="Alerts & Warnings">
      <ng-template matTabLabel>
        <mat-icon class="tab-icon">warning</mat-icon>
        Alerts & Warnings
        @if (alertsAndWarnings().length > 0) {
          <mat-chip class="count-badge alert-badge">{{ alertsAndWarnings().length }}</mat-chip>
        }
      </ng-template>

      <div class="tab-content">
        @if (alertsAndWarnings().length > 0) {
          <div class="simple-table-container">
            <table class="simple-dates-table">
              <thead>
                <tr>
                  <th>Classification</th>
                  <th>Name</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                @for (alert of alertsAndWarnings(); track $index) {
                  <tr [class.alert-row]="alert.classification === 'Alert'" [class.warning-row]="alert.classification === 'Warning'">
                    <td><strong>{{ alert.classification }}</strong></td>
                    <td>{{ alert.name }}</td>
                    <td>{{ alert.date || 'N/A' }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        } @else {
          <div class="empty-state success">
            <mat-icon>check_circle</mat-icon>
            <p>No alerts or warnings - All compliance requirements met!</p>
          </div>
        }
      </div>
    </mat-tab>

    <!-- Attachments Tab -->
    <mat-tab label="Attachments">
      <ng-template matTabLabel>
        <mat-icon class="tab-icon">attach_file</mat-icon>
        Attachments
        @if (attachments().length > 0) {
          <mat-chip class="count-badge">{{ attachments().length }}</mat-chip>
        }
      </ng-template>

      <div class="tab-content">
        @if (attachments().length > 0) {
          <app-attachment-connections
            [attachmentObjectArray]="attachments()">
          </app-attachment-connections>
        } @else {
          <div class="empty-state">
            <mat-icon>attachment</mat-icon>
            <p>No attachments associated with this contract</p>
          </div>
        }
      </div>
    </mat-tab>

    <!-- Activity Tab -->
    <mat-tab label="Activity">
      <ng-template matTabLabel>
        <mat-icon class="tab-icon">history</mat-icon>
        Activity
      </ng-template>

      <div class="tab-content">
        @if (selectedContract?.versionList && selectedContract!.versionList!.length > 0) {
          <app-versions
            entityType="contract"
            [versionList]="selectedContract!.versionList || []"
            [currentEntityNum]="selectedContract!.contractNum || ''">
          </app-versions>
        } @else {
          <div class="empty-state">
            <mat-icon>history</mat-icon>
            <p>No activity or history for this contract</p>
          </div>
        }
      </div>
    </mat-tab>

  </mat-tab-group>

</div>
